export default __webpack_public_path__ + "static/media/cesto_zucche.d433bc73.svg";